/* Move prices for certain products */
document.addEventListener('DOMContentLoaded', function () {
  const validClasses = [
    'silentball-grip',
    'silentball-silent-basketball',
    '3-silentball-grip-socks',
    '5-silentball-grip-socks'
  ];

  const bodyHasMatch = validClasses.some(cls => document.body.classList.contains(cls));

  if (bodyHasMatch) {
    const price = document.querySelector('.product-block--price');
    const salesPoint = document.querySelector('.product-block--sales-point');

    if (price && salesPoint && salesPoint.parentNode) {
      salesPoint.parentNode.insertBefore(price, salesPoint);
    }
  }
});

/* Custom variations in Training kit */
if (document.body.matches('.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit')) {
  const i18n = window.trainingKitI18n || {};

  var ballSize = document.querySelector('.variant-wrapper:first-child');
  if (ballSize) {
    var wrapper = document.createElement('div');
    wrapper.classList.add('selection-wrapper');
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-ball.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${i18n.pick_ball_size || 'Pick SilentBall size'}</span>
        <span class="included">${i18n.ball_included || '1x Ball Included'}</span>
      </div>
      <a class="size-chart right-size-button"><span>${i18n.size_guide || 'Size guide'}</span></a>
    `;
    ballSize.prepend(wrapper);
  }

  var socksSize = document.querySelector('.variant-wrapper:nth-child(2)');
  if (socksSize) {
    var wrapper = document.createElement('div');
    wrapper.classList.add('selection-wrapper');
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754547389"/>
      </div>
      <div>
        <span class="pick-your-size">${i18n.pick_socks_size || 'Pick Grip Socks size'}</span>
        <span class="included">${i18n.socks_included || '3x Pairs Included'}</span>
      </div>
      <a class="size-chart-ultimate right-size-button"><span>${i18n.size_guide || 'Size guide'}</span></a>
    `;
    socksSize.prepend(wrapper);
  }

  const labelMap = i18n.labelMap || {};

  Object.entries(labelMap).forEach(([value, [main, sub]]) => {
    const container = document.querySelector(`.variant-input[data-value="${value}"]`);
    if (container) {
      const label = container.querySelector('label');
      if (label) {
        label.innerHTML = `
          <div class="size-description">
            <span>${main}</span>
            <span>${sub}</span>
          </div>
        `;
      }
    }
  });

  const sizeTextMap = i18n.sizeTextMap || {};

  Object.entries(sizeTextMap).forEach(([dataValue, sizeText]) => {
    const container = document.querySelector(`.variant-input[data-value="${dataValue}"]`);
    if (container) {
      const lightElement = container.querySelector('.single-order-kit-item.ball .light');
      if (lightElement) {
        lightElement.textContent = sizeText;
      }
    }
  });
}

/* Training Kit before add to cart button USPs ratings */
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.matches('.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit')) {
    
    var badge = document.querySelector('.jdgm-prev-badge');

    if (badge) {
      var averageRating = badge.getAttribute('data-average-rating');
      var numberOfReviews = badge.getAttribute('data-number-of-reviews');

      var ratingEl = document.querySelector('.product-cart-usps-wrapper .usp-rating');
      var reviewsEl = document.querySelector('.product-cart-usps-wrapper .usp-reviews');

      if (ratingEl && averageRating) {
        ratingEl.textContent = averageRating;
      }

      if (reviewsEl && numberOfReviews) {
        reviewsEl.textContent = numberOfReviews;
      }
    }
  }
});

/* Change Your Training Kit values based on variant selection */
document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.matches('.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit')) return;

  const i18n = window.trainingKitI18n || {};
  const labelMap = i18n.labelMap || {};
  const sizeTextMap = i18n.sizeTextMap || {};
  const aliasMap = i18n.variantAliasMap || {};

  const getLabel = (key, fallback) => {
    if (sizeTextMap[key]) return sizeTextMap[key];
    if (labelMap[key]?.[0]) return labelMap[key][0];
    return fallback;
  };

  function applyVariantSubtexts() {
    document.querySelectorAll(":is(.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit) .variant-input[data-value]").forEach((container) => {
      const rawValue = container.getAttribute("data-value") || "";
      const canonical = aliasMap[rawValue] || rawValue;

      const pair = labelMap[canonical];
      if (!pair) return;

      const label = container.querySelector("label");
      if (!label) return;

      label.innerHTML = `
        <div class="size-description">
          <span>${pair[0]}</span>
          <span>${pair[1]}</span>
        </div>
      `;
    });
  }

  function updateText() {
    document
      .querySelectorAll(':is(.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit) .variant-input input[type="radio"]:checked')
      .forEach((input) => {
        const wrapper = input.closest(".variant-input");
        if (!wrapper) return;

        const value = wrapper.getAttribute("data-value") || "";

        if (wrapper.dataset.index === "option1") {
          const target = document.querySelector(".single-order-kit-item.ball .light");
          if (!target) return;

          if (value.includes("5")) target.textContent = getLabel("5 (3-11 yrs.)", "Size 5");
          else if (value.includes("6")) target.textContent = getLabel("6 (12-13 yrs.)", "Size 6");
          else if (value.includes("7")) target.textContent = getLabel("7 (14+ yrs.)", "Size 7");
        }

        if (wrapper.dataset.index === "option2") {
          const target = document.querySelector(".single-order-kit-item.socks .light");
          if (!target) return;

          if (/S\b/i.test(value)) target.textContent = getLabel("Size S", "Size S");
          else if (/M\b/i.test(value)) target.textContent = getLabel("Size M", "Size M");
          else if (/L\b/i.test(value)) target.textContent = getLabel("Size L", "Size L");
        }
      });
  }

  document
    .querySelectorAll(':is(.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit) .variant-input input[type="radio"]')
    .forEach((input) => {
      input.addEventListener("change", updateText);
    });

  applyVariantSubtexts();
  updateText();
});

document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.matches('.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit')) return;

  const ballItem = document.querySelector(".single-order-kit-item.ball");
  const socksItem = document.querySelector(".single-order-kit-item.socks");

  const ballNotIncluded = document.querySelector(".single-order-kit-item.ball .not-included");
  const socksNotIncluded = document.querySelector(".single-order-kit-item.socks .not-included");

  const ballLight = document.querySelector(".single-order-kit-item.ball .light");
  const socksLight = document.querySelector(".single-order-kit-item.socks .light");

  const normalize = (v) => (v || "").toLowerCase().trim();

  const isBallNone = (v) => {
    const s = normalize(v);
    return s === "no ball" || s === "sin balón" || s === "sin balon";
  };

  const isSocksNone = (v) => {
    const s = normalize(v);
    return s === "no socks" || s === "sin calcetines";
  };

  const getCheckedValueForOption = (optionIndex) => {
    const checked = document.querySelector(
      `:is(.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit) .variant-input[data-index="${optionIndex}"] input[type="radio"]:checked`
    );
    const wrapper = checked?.closest(".variant-input");
    return wrapper?.getAttribute("data-value") || checked?.value || "";
  };

  function updateOpacity() {
    const ballValue = getCheckedValueForOption("option1");
    const socksValue = getCheckedValueForOption("option2");

    const ballNone = isBallNone(ballValue);
    const socksNone = isSocksNone(socksValue);

    if (ballItem) ballItem.style.opacity = ballNone ? "0.25" : "1";
    if (socksItem) socksItem.style.opacity = socksNone ? "0.25" : "1";

    if (ballNotIncluded) ballNotIncluded.style.display = ballNone ? "block" : "none";
    if (socksNotIncluded) socksNotIncluded.style.display = socksNone ? "block" : "none";

    if (ballLight) ballLight.style.display = ballNone ? "none" : "block";
    if (socksLight) socksLight.style.display = socksNone ? "none" : "block";
  }

  updateOpacity();

  document.querySelectorAll(':is(.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit) .variant-input input[type="radio"]').forEach((radio) => {
    radio.addEventListener("change", updateOpacity);
  });
});

/* Change product cart based on variant selection */
document.addEventListener("DOMContentLoaded", function () {
  const originalPriceEl = document.querySelector(".original-price");
  const totalPriceEl = document.querySelector(".total");
  const savingsEl = document.querySelector(".savings");

  const currencyCode = document.querySelector('.product-cart-wrapper')?.dataset.currency || 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode
    }).format(cents / 100);
  }

  function updatePrices(variant) {
    if (!variant) return;

    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;

    totalPriceEl.textContent = formatMoney(price);

    if (compareAtPrice && compareAtPrice > price) {
      originalPriceEl.textContent = formatMoney(compareAtPrice);
      savingsEl.textContent = formatMoney(compareAtPrice - price);
    } else {
      originalPriceEl.textContent = '';
      savingsEl.textContent = formatMoney(0);
    }
  }

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    updatePrices(variant);
  });

  if (window?.Shopify?.Product?.currentVariant) {
    updatePrices(window.Shopify.Product.currentVariant);
  }
});

/* Custom variations in socks and ball */
const pvI18n = window.productVariationsI18n || {};

const baseText = {
  pickYourSize: pvI18n.pick_your_size || "Pick your size",
  sizeGuide: pvI18n.size_guide || "Size guide",
  whatSizeIsRight: pvI18n.what_size_is_right || "What size is right?",

  includedPair1: pvI18n.included_pair_1 || "1x Pair Included",
  includedPairs3: pvI18n.included_pairs_3 || "3x Pairs Included",
  includedPairs5: pvI18n.included_pairs_5 || "5x Pairs Included",
  includedBall1: pvI18n.included_ball_1 || "1x Ball Included"
};

const hasAnyBodyClass = (classes) => classes.some((cls) => document.body.classList.contains(cls));

if (hasAnyBodyClass(["silentball-grip", "3-silentball-grip-socks", "5-silentball-grip-socks"])) {
  const socksLabelMap = pvI18n.socksLabelMap || {
    "Size S": ["Size S", "EU: 28-34 US: 0.5-3"],
    "Size M": ["Size M", "EU: 35-41 US: 3.5-8"],
    "Size L": ["Size L", "EU: 42-47 US: 8.5-12.5"]
  };

  Object.entries(socksLabelMap).forEach(([value, [main, sub]]) => {
    const container = document.querySelector(`.variant-input[data-value="${value}"]`);
    if (!container) return;

    const label = container.querySelector("label");
    if (!label) return;

    label.innerHTML = `
      <div class="size-description">
        <span>${main}</span>
        <span>${sub}</span>
      </div>
    `;
  });
}

if (document.body.classList.contains("silentball-grip")) {
  const socksSize = document.querySelector(".variant-wrapper:first-child");
  if (socksSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedPair1}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.sizeGuide}</span></a>
    `;
    socksSize.prepend(wrapper);
  }
}

if (document.body.classList.contains("3-silentball-grip-socks")) {
  const socksSize = document.querySelector(".variant-wrapper:first-child");
  if (socksSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedPairs3}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.whatSizeIsRight}</span></a>
    `;
    socksSize.prepend(wrapper);
  }
}

if (document.body.classList.contains("5-silentball-grip-socks")) {
  const socksSize = document.querySelector(".variant-wrapper:first-child");
  if (socksSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedPairs5}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.whatSizeIsRight}</span></a>
    `;
    socksSize.prepend(wrapper);
  }
}

if (document.body.classList.contains("silentball-silent-basketball") || document.body.classList.contains("silentball")) {
  const ballSize = document.querySelector(".variant-wrapper:first-child");
  if (ballSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-ball.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedBall1}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.whatSizeIsRight}</span></a>
    `;
    ballSize.prepend(wrapper);
  }

  const ballLabelMap = pvI18n.ballLabelMap || {
    "5 (3-11 yrs.)": ["Size 5", "Ages 3-11"],
    "6 (12-13 yrs.)": ["Size 6", "Ages 12-13"],
    "7 (14+ yrs.)": ["Size 7", "Ages 14+"]
  };

  Object.entries(ballLabelMap).forEach(([value, [main, sub]]) => {
    const container = document.querySelector(`.variant-input[data-value="${value}"]`);
    if (!container) return;

    const label = container.querySelector("label");
    if (!label) return;

    label.innerHTML = `
      <div class="size-description">
        <span>${main}</span>
        <span>${sub}</span>
      </div>
    `;
  });
}

/* Size guides */
const sgI18n = window.sizeGuidesI18n || {};
const SELECT_BALL_SIZE_TEXT = sgI18n.select_ball_size || 'Select SILENTBALL™ size';
const SIZE_GUIDE_TEXT = sgI18n.size_guide || 'Size guide';

if (
  document.body.classList.contains('silentball-advanced-bundle') ||
  document.body.classList.contains('silentball™-starter-bundle')
) {
  var ballSize = document.querySelector('.variant-wrapper:first-child');
  var ballSizeText = document.querySelector('.variant-wrapper:first-child .variant__label');

  if (ballSizeText) ballSizeText.textContent = SELECT_BALL_SIZE_TEXT;

  if (ballSize && !ballSize.querySelector('.size-chart')) {
    ballSize.insertAdjacentHTML(
      'afterbegin',
      `<a class="size-chart">${SIZE_GUIDE_TEXT}</a>`
    );
  }
}

var sizechartButton = document.querySelector('.size-chart');
var sizechartultimateButton = document.querySelector('.size-chart-ultimate');
var sizechart = document.querySelector('.size-chart-container');
var sizechartUltimate = document.querySelector('.size-chart-ultimate-container');
var sizechartClose = document.querySelectorAll('.size-chart-close');

if (sizechartButton && sizechart) {
  sizechartButton.addEventListener('click', function () {
    sizechart.classList.add('active');
  });

  const target = document.querySelector('.size-chart-container .size-chart-wrapper');
  document.addEventListener('click', (event) => {
    const path = event.composedPath ? event.composedPath() : [];
    const withinBoundaries = target ? path.includes(target) : false;
    const withinBoundaries1 = path.includes(sizechartButton);

    if (!withinBoundaries && !withinBoundaries1) {
      sizechart.classList.remove('active');
    }
  });
}

if (sizechartultimateButton && sizechartUltimate) {
  sizechartultimateButton.addEventListener('click', function () {
    sizechartUltimate.classList.add('active');
  });

  const targetUltimate = document.querySelector('.size-chart-ultimate-container .size-chart-wrapper');
  document.addEventListener('click', (event) => {
    const path = event.composedPath ? event.composedPath() : [];
    const withinBoundaries2 = targetUltimate ? path.includes(targetUltimate) : false;
    const withinBoundaries3 = path.includes(sizechartultimateButton);

    if (!withinBoundaries2 && !withinBoundaries3) {
      sizechartUltimate.classList.remove('active');
    }
  });
}

if (sizechartClose && sizechartClose.length) {
  for (var i = 0; i < sizechartClose.length; i++) {
    sizechartClose[i].onclick = function () {
      if (sizechart) sizechart.classList.remove('active');
      if (sizechartUltimate) sizechartUltimate.classList.remove('active');
    };
  }
}

/* Product tabs */
if (document.body.classList.contains('template-product')) {
  var lastTabArray = [...document.querySelectorAll('.product-block--tab')];
  var lastTab = lastTabArray.slice(-1)[0];
  if (lastTab) {
    lastTab.classList.add('last-tab');
  }
}

if (document.body.matches('.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit')) {
  var tabContent = document.querySelector('.collapsible-content .metafield-rich_text_field');
  var template = document.querySelector('#training-kit-dropdown-template');

  if (tabContent && template) {
    tabContent.innerHTML = template.innerHTML;
  }
}

/* Reviews */
var reviewsPreview = document.querySelectorAll('.jdgm-widget .jdgm-prev-badge');
var i18n = window.reviewsI18n || {};

if (reviewsPreview.length) {
  reviewsPreview.forEach(function (reviewsPreviewSingle) {
    var reviewCount =
      reviewsPreviewSingle.getAttribute('data-number-of-reviews') || '100';

    var reviewHtml = `
      <a href="#judgeme_product_reviews">
        ${i18n.based_on || 'based on'}
        <span class="review-count">${reviewCount}</span>
        ${i18n.reviews || 'reviews'}
      </a>
    `;

    reviewsPreviewSingle.insertAdjacentHTML('afterbegin', reviewHtml);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const badges = document.querySelectorAll(".jdgm-prev-badge");
  const isTrainingKit = document.body.matches('.training-kit, .training-kit-silentballacademy, .silentballacademy-training-kit');

  if (isTrainingKit) {
    badges.forEach((badge) => {
      const FORCE_TEXT = () => {
        const text = badge.querySelector(".jdgm-prev-badge__text");
        if (text && text.textContent !== "4.8") {
          text.textContent = "4.8";
        }
      };

      FORCE_TEXT();

      const mo = new MutationObserver(FORCE_TEXT);
      mo.observe(badge, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
    return;
  }

  badges.forEach((badge) => {
    const observer = new MutationObserver(() => {
      const stars = badge.querySelector(".jdgm-prev-badge__stars");
      const text = badge.querySelector(".jdgm-prev-badge__text");

      if (stars && text) {
        const score = stars.getAttribute("data-score");
        if (score) {
          text.textContent = score;
          observer.disconnect();
        }
      }
    });

    observer.observe(badge, { childList: true, subtree: true });
  });
});

/* Sticky add to cart */
window.addEventListener('scroll', function () {
  var stickyCart = document.querySelector('.sticky-add-to-cart');
  var productSection = document.querySelector('.product-section');
  if (productSection) {
    var productSectionOffset = productSection.offsetHeight;
  }
  if (stickyCart && productSectionOffset) {
    if (window.pageYOffset > productSectionOffset) {
        stickyCart.classList.add('active');
    } else {
        stickyCart.classList.remove('active');
    }
  }
})

/* Newsletter */
var newsletterForm = document.querySelector('.newsletter-section__content form');
var i18n = window.newsletterI18n || {};

if (newsletterForm) {
  if (!newsletterForm.previousElementSibling?.classList.contains('your-email')) {
    newsletterForm.insertAdjacentHTML(
      'beforebegin',
      `<span class="your-email">${i18n.your_email || 'Your email'}</span>`
    );
  }

  if (!newsletterForm.nextElementSibling?.classList.contains('agreement')) {
    newsletterForm.insertAdjacentHTML(
      'afterend',
      `<span class="agreement">${i18n.agreement_html || ''}</span>`
    );
  }
}

/* Product reviews carousel */
const reviewsSwiper = document.querySelector(
  ".reviews-swiper"
);

if (reviewsSwiper) {
  const ugcCarouselSlider = new Swiper(
    ".reviews-swiper",
    {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".reviews-slider-wrapper .swiper-pagination",
        clickable: true,
      },
    }
  );
}

/* UGC carousel */
const ugcSwiper1 = document.querySelector(
  ".ugc-swiper-1"
);

const ugcSwiper2 = document.querySelector(
  ".ugc-swiper-2"
);

if (ugcSwiper1) {
  const ugcCarouselSlider = new Swiper(
    ".ugc-swiper-1",
    {
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 3000,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      autoplay: {
        delay: 1,
      },
      breakpoints: {
        769: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 7,
        },
        1440: {
          slidesPerView: 8,
        },
      },
    }
  );
}

if (ugcSwiper2) {
  const ugcCarouselSlider = new Swiper(
    ".ugc-swiper-2",
    {
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 3000,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      autoplay: {
        delay: 1,
        reverseDirection: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 7,
        },
        1440: {
          slidesPerView: 8,
        },
      },
    }
  );
}

/* Image protection */
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("contextmenu", function (e) {
    if (e.target.tagName === "IMG") {
      e.preventDefault();
    }
  });

  document.addEventListener("dragstart", function (e) {
    if (e.target.tagName === "IMG") {
      e.preventDefault();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && e.key === "I") ||
      (e.ctrlKey && e.shiftKey && e.key === "J") ||
      (e.ctrlKey && e.key === "U")
    ) {
      e.preventDefault();
    }
  });

});

/* Subscription text change */
document.addEventListener("DOMContentLoaded", function () {
  function decodeHtml(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  function updateSubscriptionButton() {
    const btnText = document.querySelector('[data-add-to-cart-text]');
    if (!btnText) return;

    if (document.body.classList.contains('subscription')) {
      btnText.textContent = decodeHtml(
        window.theme?.strings?.subscription || 'Subscribe & Save'
      );
    } else {
      btnText.textContent = btnText.dataset.defaultText || 'Add to cart';
    }
  }

  updateSubscriptionButton();
  document.addEventListener('variant:change', updateSubscriptionButton);
});

/* SBA product UGC block */
function sbaUgcFormatDuration(seconds) {
  var minutes = Math.floor(seconds / 60);
  var rest = Math.floor(seconds % 60);
  return minutes + ':' + (rest < 10 ? '0' : '') + rest;
}

function sbaUgcSetDuration(video) {
  if (!isFinite(video.duration)) return;

  var badge = video.closest('.sba-product-ugc__card').querySelector('.sba-product-ugc__duration');
  if (badge) badge.textContent = sbaUgcFormatDuration(video.duration);
}

function sbaUgcInit() {
  document.querySelectorAll('.sba-product-ugc__video').forEach(function (video) {
    if (video.readyState >= 1) {
      sbaUgcSetDuration(video);
    } else {
      video.addEventListener('loadedmetadata', function () {
        sbaUgcSetDuration(video);
      }, { once: true });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sbaUgcInit);
} else {
  sbaUgcInit();
}

document.addEventListener('shopify:section:load', sbaUgcInit);

document.addEventListener('click', function (e) {
  var playingVideo = e.target.closest('.sba-product-ugc__card.is-playing .sba-product-ugc__video');

  if (playingVideo) {
    playingVideo.pause();
    playingVideo.closest('.sba-product-ugc__card').classList.remove('is-playing');
    return;
  }

  var playBtn = e.target.closest('.sba-product-ugc__play');
  if (!playBtn) return;

  var card = playBtn.closest('.sba-product-ugc__card');
  var video = card.querySelector('video');

  document.querySelectorAll('.sba-product-ugc__card.is-playing').forEach(function (playing) {
    playing.querySelector('video').pause();
    playing.classList.remove('is-playing');
  });

  var promise = video.play();
  if (promise && promise.catch) promise.catch(function () {});
  card.classList.add('is-playing');
});

document.addEventListener('ended', function (e) {
  if (!e.target.matches || !e.target.matches('.sba-product-ugc__video')) return;

  e.target.currentTime = 0;
  e.target.closest('.sba-product-ugc__card').classList.remove('is-playing');
}, true);

/* SBA product videos block */
function sbaVideosFind(item) {
  var root = item.closest('.sba-product-videos');
  var modal = root && document.getElementById(root.dataset.modalId);

  return modal && modal.querySelector('.sba-product-videos__stage[data-index="' + item.dataset.index + '"]');
}

function sbaVideosInit() {
  document.querySelectorAll('.sba-product-videos__modal').forEach(function (modal) {
    if (modal.parentNode === document.body) return;

    Array.prototype.slice.call(document.body.children).forEach(function (element) {
      if (element !== modal && element.id === modal.id) element.remove();
    });

    document.body.appendChild(modal);
  });
}

function sbaVideosReset(stage) {
  var video = stage.querySelector('video');

  video.pause();
  if (video.readyState > 0) video.currentTime = 0;
  stage.classList.remove('is-playing');
  stage.hidden = true;
}

function sbaVideosClose() {
  var modal = document.querySelector('.sba-product-videos__modal:not([hidden])');
  if (!modal) return;

  modal.hidden = true;
  modal.querySelectorAll('.sba-product-videos__stage').forEach(sbaVideosReset);
  document.documentElement.classList.remove('sba-videos-open');
}

function sbaVideosWarmUp(e) {
  var item = e.target.closest && e.target.closest('.sba-product-videos__item');
  var stage = item && sbaVideosFind(item);
  var video = stage && stage.querySelector('video');

  if (video && video.preload !== 'auto') video.preload = 'auto';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sbaVideosInit);
} else {
  sbaVideosInit();
}

document.addEventListener('shopify:section:load', sbaVideosInit);
document.addEventListener('pointerover', sbaVideosWarmUp);
document.addEventListener('touchstart', sbaVideosWarmUp, { passive: true });

document.addEventListener('playing', function (e) {
  if (!e.target.matches || !e.target.matches('.sba-product-videos__video')) return;

  e.target.closest('.sba-product-videos__stage').classList.add('is-playing');
}, true);

document.addEventListener('click', function (e) {
  var openStage = e.target.closest('.sba-product-videos__stage');
  if (openStage) {
    var openVideo = openStage.querySelector('video');

    if (openVideo.paused) {
      var resume = openVideo.play();
      if (resume && resume.catch) resume.catch(function () {});
    } else {
      openVideo.pause();
    }
    return;
  }

  if (e.target.closest('[data-sba-videos-close]')) {
    sbaVideosClose();
    return;
  }

  var item = e.target.closest('.sba-product-videos__item');
  if (!item) return;

  var root = item.closest('.sba-product-videos');
  var modal = document.getElementById(root.dataset.modalId);
  var stage = sbaVideosFind(item);
  if (!modal || !stage) return;

  root.querySelectorAll('.sba-product-videos__item').forEach(function (other) {
    other.classList.remove('is-active');
  });
  item.classList.add('is-active');

  modal.querySelectorAll('.sba-product-videos__stage').forEach(function (other) {
    if (other !== stage) sbaVideosReset(other);
  });

  stage.hidden = false;
  modal.hidden = false;
  document.documentElement.classList.add('sba-videos-open');

  var promise = stage.querySelector('video').play();
  if (promise && promise.catch) promise.catch(function () {});
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') sbaVideosClose();
});

/* SBA product founders block */
function sbaFoundersFormatDuration(seconds) {
  var minutes = Math.floor(seconds / 60);
  var rest = Math.floor(seconds % 60);
  return minutes + ':' + (rest < 10 ? '0' : '') + rest;
}

function sbaFoundersSetDuration(video) {
  if (!isFinite(video.duration)) return;

  var badge = video.closest('.sba-product-founders__card').querySelector('.sba-product-founders__duration');
  if (badge) badge.textContent = sbaFoundersFormatDuration(video.duration);
}

function sbaFoundersInit() {
  document.querySelectorAll('.sba-product-founders__video').forEach(function (video) {
    if (video.readyState >= 1) {
      sbaFoundersSetDuration(video);
    } else {
      video.addEventListener('loadedmetadata', function () {
        sbaFoundersSetDuration(video);
      }, { once: true });
    }
  });

  document.querySelectorAll('.sba-product-founders__modal').forEach(function (modal) {
    if (modal.parentNode === document.body) return;

    Array.prototype.slice.call(document.body.children).forEach(function (element) {
      if (element !== modal && element.id === modal.id) element.remove();
    });

    document.body.appendChild(modal);
  });

}

function sbaFoundersReset(stage) {
  var video = stage.querySelector('video');

  video.pause();
  if (video.readyState > 0) video.currentTime = 0;
  stage.classList.remove('is-playing');
  stage.hidden = true;
}

function sbaFoundersClose() {
  var modal = document.querySelector('.sba-product-founders__modal:not([hidden])');
  if (!modal) return;

  modal.hidden = true;
  modal.querySelectorAll('.sba-product-founders__stage').forEach(sbaFoundersReset);
  document.documentElement.classList.remove('sba-founders-open');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sbaFoundersInit);
} else {
  sbaFoundersInit();
}

document.addEventListener('shopify:section:load', sbaFoundersInit);

document.addEventListener('playing', function (e) {
  if (!e.target.matches || !e.target.matches('.sba-product-founders__popup-video')) return;

  e.target.closest('.sba-product-founders__stage').classList.add('is-playing');
}, true);

document.addEventListener('click', function (e) {
  var openStage = e.target.closest('.sba-product-founders__stage');
  if (openStage) {
    var openVideo = openStage.querySelector('video');

    if (openVideo.paused) {
      var resume = openVideo.play();
      if (resume && resume.catch) resume.catch(function () {});
    } else {
      openVideo.pause();
    }
    return;
  }

  if (e.target.closest('[data-sba-founders-close]')) {
    sbaFoundersClose();
    return;
  }

  var playBtn = e.target.closest('.sba-product-founders__play');
  if (!playBtn) return;

  var root = playBtn.closest('.sba-product-founders');
  var modal = document.getElementById(root.dataset.modalId);
  var stage = modal && modal.querySelector('.sba-product-founders__stage');
  if (!stage) return;

  stage.hidden = false;
  modal.hidden = false;
  document.documentElement.classList.add('sba-founders-open');

  var promise = stage.querySelector('video').play();
  if (promise && promise.catch) promise.catch(function () {});
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') sbaFoundersClose();
});

/* SBA product urgency block: counts down to 23:59 in GMT+2 */
(function () {
  var UTC_OFFSET_HOURS = 2;
  var DEADLINE_HOUR = 23;
  var DEADLINE_MINUTE = 59;

  function pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  function updateSbaUrgency() {
    var timers = document.querySelectorAll('.sba-product-urgency__timer');
    if (!timers.length) return;

    var now = new Date(Date.now() + UTC_OFFSET_HOURS * 3600000);
    var end = new Date(now.getTime());
    end.setUTCHours(DEADLINE_HOUR, DEADLINE_MINUTE, 0, 0);

    var distance = end - now;
    if (distance <= 0) distance += 86400000;

    var hours = Math.floor(distance / 3600000) % 24;
    var minutes = Math.floor(distance / 60000) % 60;
    var seconds = Math.floor(distance / 1000) % 60;
    var text = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

    timers.forEach(function (timer) {
      timer.textContent = text;
    });
  }

  updateSbaUrgency();
  setInterval(updateSbaUrgency, 1000);
})();

/* SBA gallery counter: updates "current / total" when the main product slide changes */
(function () {
  function updateSbaGalleryCounter() {
    var counter = document.querySelector('[data-gallery-counter]');
    if (!counter) return;

    var slider = counter.closest('.product__main-photos');
    var current = counter.querySelector('[data-gallery-counter-current]');
    var selected = slider && slider.querySelector('.product-main-slide.is-selected');
    if (!current || !selected) return;

    current.textContent = parseInt(selected.dataset.index, 10) + 1;
  }

  function initSbaGalleryCounter() {
    var counter = document.querySelector('[data-gallery-counter]');
    if (!counter) return;

    var slider = counter.closest('.product__main-photos');
    if (!slider) return;

    updateSbaGalleryCounter();

    new MutationObserver(updateSbaGalleryCounter).observe(slider, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSbaGalleryCounter);
  } else {
    initSbaGalleryCounter();
  }

  document.addEventListener('shopify:section:load', initSbaGalleryCounter);
})();

/* SBA product selector: swaps the variant in the main add to cart form and the sticky add to cart */
(function () {
  function getRoot() {
    return document.querySelector('[data-sba-selector]');
  }

  function getForm(root) {
    var section = root.closest('.product-section') || document;
    return section.querySelector('.product-single__form');
  }

  function getActive(root) {
    return {
      card: root.querySelector('.sba-selector__card.is-selected'),
      panel: root.querySelector('.sba-selector__panel:not([hidden])')
    };
  }

  function findVariant(panel) {
    var variants = JSON.parse(panel.dataset.variants || '[]');
    var selects = panel.querySelectorAll('.sba-selector__select');

    if (!selects.length) {
      return variants.filter(function (variant) {
        return variant.available;
      })[0] || variants[0] || null;
    }

    var values = [];
    selects.forEach(function (select) {
      values[parseInt(select.dataset.index, 10)] = select.value;
    });

    return variants.filter(function (variant) {
      return variant.options.every(function (option, index) {
        return option === values[index];
      });
    })[0] || null;
  }

  function applyLabel(root, el, card, available) {
    if (!el) return;

    if (!el.dataset.sbaDefault) {
      el.dataset.sbaDefault = el.dataset.defaultText || el.textContent.trim();
    }

    var text = (card && card.dataset.atcText) || el.dataset.sbaDefault;

    if (el.hasAttribute('data-default-text')) {
      el.dataset.defaultText = text;
    }

    el.textContent = available ? text : root.dataset.soldOutText;
  }

  function updateForm(root, variant, card) {
    var form = getForm(root);
    if (!form) return;

    var select = form.querySelector('select[name="id"]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonText = form.querySelector('[data-add-to-cart-text]');
    var available = !!(variant && variant.available);

    if (select && variant) {
      var previous = select.querySelector('[data-sba-selector-option]');
      if (previous) previous.remove();

      var option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.id;
      option.setAttribute('data-sba-selector-option', '');
      select.appendChild(option);
      select.value = variant.id;
    }

    if (button) button.disabled = !available;

    applyLabel(root, buttonText, card, available);
    applyLabel(root, document.querySelector('.sticky-add-to-cart .btn'), card, available);
  }

  function updateSticky(card) {
    var sticky = document.querySelector('.sticky-add-to-cart');
    if (!sticky || !card) return;

    var title = sticky.querySelector('.grid-product__title');
    var image = sticky.querySelector('.info-wrapper img');
    var price = sticky.querySelector('.product-price');

    if (title && card.dataset.title) title.textContent = card.dataset.title;
    if (image && card.dataset.image) image.src = card.dataset.image;

    if (price) {
      price.innerHTML = '';

      var current = document.createElement('span');
      current.className = card.dataset.compare ? 'price--sale' : 'price';
      current.textContent = card.dataset.price;
      price.appendChild(current);

      if (card.dataset.compare) {
        var compare = document.createElement('span');
        var strike = document.createElement('s');
        compare.className = 'price--compare';
        strike.textContent = card.dataset.compare;
        compare.appendChild(strike);
        price.appendChild(compare);
      }
    }
  }

  function update(root) {
    var active = getActive(root);
    if (!active.panel) return;

    updateForm(root, findVariant(active.panel), active.card);
    updateSticky(active.card);
  }

  function selectSystem(root, system) {
    var panelToShow = null;

    root.querySelectorAll('.sba-selector__card').forEach(function (card) {
      var isActive = card.dataset.system === String(system);
      card.classList.toggle('is-selected', isActive);
      card.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('.sba-selector__panel').forEach(function (panel) {
      var isActive = panel.dataset.panel === String(system);
      panel.hidden = !isActive;
      if (isActive) panelToShow = panel;
    });

    var sizes = root.querySelector('.sba-selector__sizes');
    if (sizes) {
      sizes.hidden = !(panelToShow && panelToShow.querySelector('.sba-selector__row'));
    }

    update(root);
  }

  function openGuide(trigger) {
    var modal = document.getElementById(trigger.dataset.guideId);
    if (!modal) return;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    modal.hidden = false;
    document.documentElement.classList.add('sba-guide-open');
  }

  function closeGuide() {
    var modal = document.querySelector('.sba-selector__guide:not([hidden])');
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('sba-guide-open');
  }

  function initSbaSelector() {
    var root = getRoot();
    if (!root) return;

    var defaultCard = root.querySelector('.sba-selector__card[data-system="' + root.dataset.defaultSystem + '"]')
      || root.querySelector('.sba-selector__card');

    if (defaultCard) selectSystem(root, defaultCard.dataset.system);
  }

  document.addEventListener('click', function (e) {
    var guideButton = e.target.closest('[data-sba-guide-open]');
    if (guideButton) {
      e.preventDefault();
      openGuide(guideButton);
      return;
    }

    if (e.target.closest('[data-sba-guide-close]')) {
      closeGuide();
      return;
    }

    var card = e.target.closest('.sba-selector__card');
    if (card) {
      selectSystem(card.closest('[data-sba-selector]'), card.dataset.system);
      return;
    }

    var stickyButton = e.target.closest('.sticky-add-to-cart .btn');
    var root = getRoot();
    if (!stickyButton || !root) return;

    var form = getForm(root);
    var addButton = form && form.querySelector('[data-add-to-cart]');
    if (!addButton) return;

    e.preventDefault();
    if (!addButton.disabled) addButton.click();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeGuide();
      return;
    }

    if (e.key !== 'Enter' && e.key !== ' ') return;

    var guideButton = e.target.closest && e.target.closest('[data-sba-guide-open]');
    if (guideButton) {
      e.preventDefault();
      openGuide(guideButton);
      return;
    }

    var card = e.target.closest && e.target.closest('.sba-selector__card');
    if (!card) return;

    e.preventDefault();
    selectSystem(card.closest('[data-sba-selector]'), card.dataset.system);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.sba-selector__select')) return;

    update(e.target.closest('[data-sba-selector]'));
  });

  document.addEventListener('submit', function (e) {
    var root = getRoot();
    if (!root || !e.target.matches || !e.target.matches('.product-single__form')) return;

    if (e.target.closest('.product-section') === root.closest('.product-section')) {
      update(root);
    }
  }, true);

  window.addEventListener('load', function () {
    var root = getRoot();
    if (root) update(root);
  });

  document.addEventListener('variant:change', function () {
    var root = getRoot();
    if (root) setTimeout(function () { update(root); }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSbaSelector);
  } else {
    initSbaSelector();
  }

  document.addEventListener('shopify:section:load', initSbaSelector);
})();

/* Smart sticky header: hides while scrolling down, shows again when scrolling up */
(function () {
  var DELTA = 8;
  var wrapper = null;
  var naturalTop = 0;
  var lastY = 0;
  var ticking = false;
  var bound = false;

  function setHidden(hidden) {
    if (wrapper) wrapper.classList.toggle('is-hidden', hidden);
  }

  function update() {
    ticking = false;
    if (!wrapper || !wrapper.isConnected) return;

    var y = Math.max(window.scrollY, 0);
    var top = wrapper.getBoundingClientRect().top;
    var height = wrapper.offsetHeight;

    if (top > 1) {
      naturalTop = top + y;
      setHidden(false);
      lastY = y;
      return;
    }

    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;

    if (diff > 0) {
      if (y > naturalTop + height) setHidden(true);
    } else {
      setHidden(false);
    }

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    var siteHeader = document.getElementById('SiteHeader');
    if (!siteHeader || siteHeader.dataset.sticky === 'true' || siteHeader.dataset.overlay === 'true') return;

    var section = siteHeader.closest('.shopify-section');
    wrapper = siteHeader.closest('.header-sticky-wrapper');
    if (!section || !wrapper) return;

    section.classList.add('sba-smart-header');

    naturalTop = 0;
    var previous = section.previousElementSibling;
    while (previous) {
      naturalTop += previous.offsetHeight;
      previous = previous.previousElementSibling;
    }

    var toolbar = section.querySelector('.toolbar');
    if (toolbar) naturalTop += toolbar.offsetHeight;

    lastY = Math.max(window.scrollY, 0);
    update();

    if (!bound) {
      window.addEventListener('scroll', onScroll, { passive: true });
      bound = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* SBA product title: rating and review count from the Judge.me widget */
(function () {
  var tries = 0;

  function findSource(attribute) {
    return document.querySelector('.jdgm-rev-widg[' + attribute + '], .jdgm-rev-widg [' + attribute + ']');
  }

  function formatRating(value) {
    var number = parseFloat(value);
    if (!isFinite(number) || number <= 0) return '';

    return number.toFixed(2) + '/5';
  }

  function formatCount(value) {
    var number = parseInt(value, 10);
    if (!isFinite(number) || number <= 0) return '';

    return number.toLocaleString(document.documentElement.lang || undefined);
  }

  function buildReviewsText(template, count) {
    if (template.indexOf('{count}') !== -1) {
      return template.replace('{count}', count);
    }

    if (/\d/.test(template)) {
      return template.replace(/\d[\d.,\s]*\d|\d/, count);
    }

    return count + ' ' + template;
  }

  function updateSbaRating() {
    var score = document.querySelector('.sba-product-title__score');
    var reviews = document.querySelector('.sba-product-title__reviews');
    var scoreDone = !score;
    var reviewsDone = !reviews;

    if (score) {
      var ratingSource = findSource('data-average-rating');
      var ratingText = ratingSource ? formatRating(ratingSource.getAttribute('data-average-rating')) : '';

      if (ratingText) {
        score.textContent = ratingText;
        scoreDone = true;
      }
    }

    if (reviews) {
      var countSource = findSource('data-number-of-reviews');
      var countText = countSource ? formatCount(countSource.getAttribute('data-number-of-reviews')) : '';

      if (countText) {
        if (!reviews.dataset.template) reviews.dataset.template = reviews.textContent.trim();
        reviews.textContent = buildReviewsText(reviews.dataset.template, countText);
        reviewsDone = true;
      }
    }

    return scoreDone && reviewsDone;
  }

  function initSbaRating() {
    if (!document.querySelector('.sba-product-title__score, .sba-product-title__reviews')) return;

    tries = 0;
    if (updateSbaRating()) return;

    var timer = setInterval(function () {
      tries += 1;
      if (updateSbaRating() || tries >= 40) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSbaRating);
  } else {
    initSbaRating();
  }

  document.addEventListener('shopify:section:load', initSbaRating);
})();

/* Redirect old SilentBall product handles to training-kit (any language/market) */
(function () {
    var handles = ['silentball-complete', 'silentball-core', 'silentball-entry'];
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);

    if (!match || handles.indexOf(match[1].toLowerCase()) === -1) {
        return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var params = new URLSearchParams(window.location.search);
    params.delete('variant');
    var query = params.toString();

    window.location.replace(
        root + 'products/training-kit' + (query ? '?' + query : '') + window.location.hash
    );
})();

/* SBA single upsell: add the assigned product to cart without opening the side cart, press again to remove it */
(function () {
  var nativeWindow = null;
  var syncTimers = [];

  function getNativeWindow() {
    if (nativeWindow) return nativeWindow;

    try {
      var frame = document.createElement('iframe');
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
      document.body.appendChild(frame);
      nativeWindow = frame.contentWindow;
    } catch (e) {
      nativeWindow = null;
    }

    return nativeWindow;
  }

  function sendToCart(url, options) {
    var frameWindow = getNativeWindow();
    var absoluteUrl = new URL(url, window.location.origin).href;

    if (frameWindow && typeof frameWindow.fetch === 'function') {
      return frameWindow.fetch(absoluteUrl, options);
    }

    return fetch(absoluteUrl, options);
  }

  function showError(form, message) {
    var error = form.querySelector('.sba-single-upsell__error');
    if (!error) return;

    error.textContent = message || '';
    error.hidden = !message;
  }

  function setAdded(button, added) {
    if (!button.dataset.defaultText) {
      button.dataset.defaultText = button.textContent.trim();
    }

    if (added) {
      button.textContent = button.dataset.addedText || '✓ Added';
      button.classList.add('is-added');
    } else {
      button.textContent = button.dataset.defaultText;
      button.classList.remove('is-added');
    }
  }

  function refreshCart() {
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }

    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function syncButtons() {
    if (!document.querySelector('[data-sba-single-upsell]')) return;

    var started = Date.now();
    var separator = theme.routes.cart.indexOf('?') === -1 ? '?' : '&';

    sendToCart(theme.routes.cart + separator + 't=' + started, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var ids = (cart.items || []).map(function (item) {
          return String(item.variant_id);
        });

        document.querySelectorAll('[data-sba-single-upsell]').forEach(function (form) {
          var input = form.querySelector('[name="id"]');
          var button = form.querySelector('.sba-single-upsell__button');

          if (
            !input ||
            !button ||
            button.disabled ||
            button.classList.contains('is-loading')
          ) return;

          if (Number(button.dataset.addedAt || 0) > started) return;

          setAdded(button, ids.indexOf(input.value) !== -1);
        });
      })
      .catch(function () {});
  }

  function scheduleSync() {
    if (!document.querySelector('.sba-single-upsell__button.is-added')) return;

    syncTimers.forEach(clearTimeout);
    syncTimers = [
      setTimeout(syncButtons, 700),
      setTimeout(syncButtons, 2000)
    ];
  }

  function initDrawerFallback() {
    var tries = 0;

    function subscribe() {
      if (typeof window.upcartSubscribeAddedToCart === 'function') {
        window.upcartSubscribeAddedToCart(function () {
          if (
            Date.now() - (window.sbaUpsellAddedAt || 0) < 3000 &&
            typeof window.upcartCloseCart === 'function'
          ) {
            window.upcartCloseCart();
          }
        });

        return true;
      }

      return false;
    }

    if (subscribe()) return;

    var timer = setInterval(function () {
      tries += 1;

      if (subscribe() || tries >= 20) {
        clearInterval(timer);
      }
    }, 500);
  }

  function finish(button, form, request, onSuccess) {
    request
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status === 422 || data.status === 404) {
          showError(form, data.description || data.message);
          return;
        }

        onSuccess();
        refreshCart();
      })
      .catch(function () {
        showError(form, 'Something went wrong. Please try again.');
      })
      .then(function () {
        if (button) button.classList.remove('is-loading');
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (
      !form ||
      !form.matches ||
      !form.matches('[data-sba-single-upsell]')
    ) return;

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector('.sba-single-upsell__button');
    var input = form.querySelector('[name="id"]');

    if (!input) return;
    if (button && button.classList.contains('is-loading')) return;

    var removing = !!button && button.classList.contains('is-added');

    if (button) {
      if (!button.dataset.defaultText) {
        button.dataset.defaultText = button.textContent.trim();
      }

      button.classList.add('is-loading');
    }

    showError(form, '');

    if (removing) {
      finish(button, form, sendToCart(theme.routes.cartChange, {
        method: 'POST',
        body: JSON.stringify({
          id: input.value,
          quantity: 0
        }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }), function () {
        button.dataset.addedAt = Date.now();
        setAdded(button, false);
      });

      return;
    }

    window.sbaUpsellAddedAt = Date.now();

    finish(button, form, sendToCart(theme.routes.cartAdd, {
      method: 'POST',
      body: new URLSearchParams(new FormData(form)).toString(),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }), function () {
      window.sbaUpsellAddedAt = Date.now();

      if (button) {
        button.dataset.addedAt = Date.now();
        setAdded(button, true);
      }
    });
  }, true);

  window.addEventListener('click', scheduleSync, true);
  window.addEventListener('change', scheduleSync, true);
  window.addEventListener('pageshow', syncButtons);
  document.addEventListener('shopify:section:load', syncButtons);

  function init() {
    initDrawerFallback();
    syncButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();